import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../core/services/api.service';
import { LocalService } from '../../../core/services/local.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { forkJoin, Observable } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { SpiritImagePipe } from '../../../core/pipes/spiritImage';
import { SpiritTranslationPipe } from '../../../core/pipes/spiritTranslation';
import { CatalogTranslationPipe } from '../../../core/pipes/catalogTranslation';

const materialModules = [
  MatIconModule,
  MatButtonModule,
  MatSnackBarModule,
  FormsModule,
  MatInputModule
]

const pipes = [
  SpiritImagePipe,
  SpiritTranslationPipe,
  CatalogTranslationPipe
]

@Component({
  selector: 'app-locker-new-order',
  templateUrl: './new-order.component.html',
  styleUrls: ['./new-order.component.scss'],
  standalone: true,
  imports: [
    TranslateModule, ...materialModules, ...pipes
  ]
})

export class NewOrderComponent  implements OnInit {

  @Output() newOrder = new EventEmitter<any>();

  api = inject(ApiService);
  local = inject(LocalService);
  translate = inject(TranslateService);

  stockOk: boolean = true;
  total: number = 0;
  orderDone: boolean = false;

  lockerUser: any = null;
  lockerCart: any[] = [];

  spiritWithoutPrice: boolean = false;

  menu: any;

  constructor(
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    const lockerUser = this.local.getData('lockerUser');
    if (lockerUser) {
      this.lockerUser = JSON.parse(lockerUser);
    }

    const lockerCartString = this.local.getData('lockerCart');
    if (lockerCartString) {
      this.lockerCart = JSON.parse(lockerCartString);
    }

    this.getMenu();
    this.getCartSpirits();
    this.calculateTotal();
  }

  getMenu() {
    this.api.getMenu().subscribe(
      data => {
        this.menu = data;
      }
    );
  }

  confirmOrder() {
    const requests: Observable<any>[] = [];

    this.lockerCart.forEach(lockerSpirit => {
      if (lockerSpirit.quantity > 0) {
        const spirit = lockerSpirit.spirit;
        const req = this.api.lockerCreateOrder(
          this.lockerUser.code,
          spirit.uuid,
          lockerSpirit.quantity,
          lockerSpirit.price
        );
        requests.push(req);
      }
    });

    forkJoin(requests).subscribe({
      next: (responses) => {
        this.orderDone = true;
      },
      error: (err) => {
        this.orderDone = true;
      },
      complete: () => {
        this.newOrder.emit();
        
        setTimeout(() => {
          this.local.removeData('lockerCart');
          this.lockerCart = [];
          this.orderDone = false;
        }, 5000);
      }
    });
  }
  
  getCartSpirits() {
    this.lockerCart.forEach(lockerSpirit => {
      const spirit = lockerSpirit.spirit;
      this.api.getCompanySpirit(spirit.uuid).subscribe(
        data => {
          console.log({data});
          const apiSpirit = data;
          if (apiSpirit.stock && apiSpirit.stock.stockActive && apiSpirit.stock.stock != 0) {
            lockerSpirit.quantity = Math.min(lockerSpirit.quantity, apiSpirit.stock.stock);
            lockerSpirit.maxQty = apiSpirit.stock.stock;
            this.updateCart();
          }
        }
      );
    });
  }

  updateCart() {
    this.removeEmptyLockerSpirits();
    this.local.saveData('lockerCart', JSON.stringify(this.lockerCart));
    this.calculateTotal();
  }

  removeEmptyLockerSpirits() {
    this.lockerCart = this.lockerCart.filter(x => x.quantity > 0);
  }

  substractQty(lockerSpirit: any) {
    lockerSpirit.quantity--;
    this.updateCart();
  }

  addQty(lockerSpirit: any) {
    const spirit = lockerSpirit.spirit;
    if (
      !this.menu.user.activeModules.includes('erp') ||
      !spirit.stock ||
      (spirit.stock && !spirit.stock!.stockActive) ||
      (spirit.stock && lockerSpirit.quantity < spirit.stock!.stock && spirit.stock!.stockActive)
    ) {
      lockerSpirit.quantity++;
    } 
    this.updateCart();
  }

  calculateTotal() {
    let total = 0;
    let qty = 0;
    this.lockerCart.forEach(lockerSpirit => {
      qty += lockerSpirit.quantity;
      total += lockerSpirit.price * qty;
      if (lockerSpirit.price == 0) {
        this.spiritWithoutPrice = true;
      }
    });
    this.total = total;
  }

  showMaxQtyAlert(variant: string, wine: string, maxQty: number = 6) {
    this.snackBar.open(this.translate.instant('wine_locker_max_qty_alert', {variant, wine, maxQty}), '', {
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 5000,
      panelClass: ['max-qty-alert-snackbar']
    });
  }

  toFixed(n: number) {
    return n.toFixed(2);
  }

}